import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@mzc-pdc/ui";
import theme from "@styles/theme";

const TableCard = ({ name, subName, thumbnail, sx }) => {
    const { checkboxWidth } = sx ?? {};
    const [thumbnailProps, setThumbnailProps] = useState({});
    const thumbnailRef = React.useRef(null);

    useEffect(() => {
        if (!thumbnailRef.current) return;

        const updateThumbnailWidth = () => {
            if (thumbnailRef.current) {
                const rect = thumbnailRef.current.getBoundingClientRect();
                if (rect.width !== thumbnailProps.width) {
                    setThumbnailProps({ width: rect.width });
                }
            }
        };

        // 요소가 화면에 보이는지 감지하는 IntersectionObserver
        const intersectionObserver = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    updateThumbnailWidth();
                }
            },
            { threshold: 0.1 },
        );

        if (thumbnailRef.current) {
            updateThumbnailWidth();
            intersectionObserver.observe(thumbnailRef.current);
        }

        // 클린업 함수
        return () => {
            if (thumbnailRef.current) {
                intersectionObserver.unobserve(thumbnailRef.current);
            }
            intersectionObserver.disconnect();
        };
    }, []);

    return (
        <Grid container flexDirection={"row"} alignItems={"center"}>
            <Grid item ref={thumbnailRef}>
                {thumbnail && thumbnail}
            </Grid>
            <Grid
                item
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: `calc(100% - ${thumbnailProps?.width}px - ${checkboxWidth ?? 0}px - 12px)`,
                    ml: theme.spacing(1.5),
                    gap: theme.spacing(0.5),
                }}
            >
                <Grid item sx={{ display: "flex", flexDirection: "row" }}>
                    <Grid item>{name?.startIcon && name?.startIcon}</Grid>
                    <Grid
                        item
                        sx={{
                            display: "flex",
                            overflow: "hidden",
                            flex: 1,
                        }}
                    >
                        <div
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                                minWidth: 0,
                            }}
                        >
                            {name?.name && name?.name}
                        </div>
                    </Grid>
                    {name?.endIcon && name?.endIcon}
                </Grid>
                {subName && (
                    <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                        <Grid item sx={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
                            {subName.name && subName.name}
                            {subName.icons && subName.icons}
                        </Grid>
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};
TableCard.propTypes = {};

export default TableCard;
